import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { Globals } from 'app/_globals';
import { Pagination } from 'app/_models/pagination.model';
import { SiteFormResponse } from 'app/_models/site-forms/site-form-response.model';
import { SiteFormsService } from 'app/_services/site-forms.service';
import { environment } from 'environments/environment';
import { SortEvent } from 'primeng/api';

@Component({
  selector: 'site-form-responses-table',
  templateUrl: './site-form-responses-table.component.html',
})
export class SiteFormsResponsesTableComponent implements OnInit {
  @Input() tableOptions: any;
  @Input() siteFormId: any;

  public routeRole: string;
  public tableData: SiteFormResponse[]

  // pagination
  public pageSizes: any = environment.perPageOptionsSmall;
  public pagination: Pagination;
  @ViewChild('paginator', { static: true }) paginator;

  // Sorting and Filtering
  public defaultSortField = 'createdDate';
  public defaultSortOrder = -1;
  private sortOrderToText = (sortOrder: number) => { return sortOrder === 1 ? 'asc' : 'desc'; }
  public selectedSort = [this.defaultSortField + ',' + this.sortOrderToText(this.defaultSortOrder)];

  constructor(
    private siteFormService: SiteFormsService,
    private router: Router,
    globals: Globals,
  ) {
    this.routeRole = globals.user.routeRole;
  }

  ngOnInit() {
    this.resetPagination(); // call service to populate table
  }

  private fetchTableData() {
    this.siteFormService.getAllSiteFormResponsesForForm(this.siteFormId, this.pagination, this.selectedSort).subscribe(response => {
      this.tableData = response.body;

      this.pagination.totalRecords = response.totalRecords;
    });
  }

  public paginate(event) {
    this.pagination.size = event.rows;
    this.pagination.page = event.page;
    this.fetchTableData();
  }

  private resetPagination() {
    this.pagination = {
      size: this.pageSizes[0],
      page: 0,
      totalRecords: 0,
    };
    this.goToFirstPage();
    this.fetchTableData();
  }

  public customSort(sort: SortEvent) {
    const sortDirection = this.sortOrderToText(sort.order);

    this.selectedSort = [sort.field + ',' + sortDirection];

    this.goToFirstPage();

    this.fetchTableData();
  }

  private goToFirstPage() {
    this.pagination.page = 0;      // Backend: reset page index to fetch from API
    if (this.paginator) {
      this.paginator.first = 0;    // Frontend: update visual page indicator (PrimeNg)
    }
  }
}
